import gql from 'graphql-tag'

export const CREATE_TOKEN = gql`
  mutation CreateToken(
    $email: String!
    $password: String!
  ) {
    createToken(
      email: $email
      password: $password
    ) {
      token
    }
  }
`

export const UPDATE_PASSWORD = gql`
  mutation UpdatePassword($newPassword: String!) {
    updatePassword(newPassword: $newPassword) {
      token
    }
  }
`
